<script lang="ts">
  import { apiFetch } from "services/fetch-wrapper";
  import JobGroup from "./JobGroup.svelte";
  import { onMount } from "svelte";
  import { getApiUrl } from "config";
  import { orgPlus } from "@nrk/origo";
  import { userBelongsToStillsGroup } from "auth/auth";

  let jobs = [];
  let lastUpdated = new Date();
  let userBelongsInStillsGroup = false;

  async function fetchJobs() {
    const response = await apiFetch(`${getApiUrl()}/tickets/latest`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    lastUpdated = new Date();
    jobs = await response.json();
  }

  onMount(() => {
    userBelongsInStillsGroup = userBelongsToStillsGroup() ?? false;
    if (userBelongsInStillsGroup) {
      fetchJobs();
      const interval = setInterval(fetchJobs, 10000);
      return () => clearInterval(interval);
    }
  });
</script>

<div class="jobs-container">
  {#if userBelongsInStillsGroup}
    <h2>Oppdrag</h2>
    <a href="https://felt.nrk.no/tickets" target="_blank" rel="noopener noreferrer">
      {@html orgPlus} Nytt oppdrag
    </a>
    <div>
      {#each jobs as job}
        <JobGroup {job} />
      {/each}
    </div>
    <small>Sist oppdatert: {lastUpdated.toLocaleTimeString()}</small>
  {:else}
    <p>
      Du må være medlem av Stills-gruppen for å se pågående <strong>Oppdrag</strong>. Hør med
      reportasjeleder for å få tilgang til <i>Brukere Bildebanken Stills</i>
    </p>
  {/if}
</div>

<style>
  .jobs-container {
    margin: var(--org-medium);
  }
  h2 {
    margin-bottom: var(--org-medium);
  }
</style>
